import { io } from 'socket.io-client';
import { SERVER_ROOT } from './env';

// "undefined" means the URL will be computed from the `window.location` object

const socket = io(SERVER_ROOT + '/user', {
	autoConnect: false,
	reconnection: true,
	"reconnection limit": 2000,
	"max reconnection attempts": 4,
    withCredentials: true,
	cors: {
	    origin: SERVER_ROOT,
	    methods: ["GET", "POST"]
	}
});

socket.customPayload = {};
socket.pendingMessages = [];
socket.isConnecting = false;

const flushPendingMessages = () => {
  while (socket.connected && socket.pendingMessages.length > 0) {
    const { event, message } = socket.pendingMessages.shift();
    socket.emit(event, message);
  }
};

socket.on("connect", () => {
  socket.isConnecting = false;
  flushPendingMessages();
});

socket.on("disconnect", () => {
  socket.isConnecting = false;
});

// Function to send a message
socket.checkAndEmit = function(event, message) {
  if (socket.connected) {
    socket.emit(event, message);
    return;
  }

  socket.pendingMessages.push({ event, message });

  if (!socket.isConnecting) {
    socket.isConnecting = true;
    socket.connect();
  }
};

export default socket;